import type { Lang } from '../../lib/i18n'
import { Button } from '../../components/ui/button'
import { Ltr } from './Ltr'
import { ot } from './orders-i18n'

interface Props {
  lang: Lang
  secondsLeft: number
  onUndo: () => void
}

export function UndoToast({ lang, secondsLeft, onUndo }: Props) {
  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-4 z-40 mx-auto flex max-w-md items-center justify-between gap-4 rounded-xl border bg-foreground px-4 py-3 text-background shadow-lg sm:inset-x-auto sm:end-4"
    >
      <span className="text-sm font-medium">
        {ot(lang, 'statusUpdated')} · <Ltr>{secondsLeft}s</Ltr>
      </span>
      <Button variant="secondary" size="sm" className="min-h-[44px] shrink-0" onClick={onUndo}>
        {ot(lang, 'undo')}
      </Button>
    </div>
  )
}
